import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { ApiIcon, color } from '@coursera/coursera-ui';
import { SvgTrash } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/enterprise-admin-users';

type Props = {
  files: Array<File>;
  onDelete?: (file?: File) => void;
  status?: string;
};

const BYTES_IN_KB = 1024;
const BYTES_IN_MB = BYTES_IN_KB * BYTES_IN_KB;

const getFileSize = (size: number) => {
  if (size < BYTES_IN_KB) {
    return <FormattedMessage message={_t('{fileSize} bytes')} fileSize={size} />;
  } else if (size < BYTES_IN_MB) {
    return <FormattedMessage message={_t('{fileSize} KB')} fileSize={Math.round(size / BYTES_IN_KB).toString()} />;
  } else {
    return <FormattedMessage message={_t('{fileSize} MB')} fileSize={Math.round(size / BYTES_IN_MB).toString()} />;
  }
};

const CSVPreUploadPreview = ({ files = [], onDelete, status = 'API_SUCCESS' }: Props) => (
  <div className="rc-CSVPreUploadPreview2">
    {files.map((file) => (
      <div key={file.name} className="horizontal-box m-t-1 align-items-spacebetween">
        <div className="horizontal-box">
          <ApiIcon apiStatus={status} />
          <p className="font-weight-bold m-l-1 m-r-1 m-b-0">{file.name}</p>
          <p className="m-b-0 m-r-1 color-hint-text">{getFileSize(file.size)}</p>
        </div>
        {onDelete && (
          <SvgTrash style={{ cursor: 'pointer' }} hoverColor={color.primary} onClick={() => onDelete(file)} size={20} />
        )}
      </div>
    ))}
  </div>
);

export default CSVPreUploadPreview;
